import type { Column, GridApi } from "ag-grid-community";
import { useUpdateCellByValueAndOperation } from "./useUpdateCellByValueAndOperation";
import { initGridSettings, useGridSettingsSelect } from "../../../data";
import { isNullish } from "remeda";

export const useUpdateColumnFromCellByValueAndOperation = () => {
  const updateCellsByValueAndOperation = useUpdateCellByValueAndOperation();
  const months = useGridSettingsSelect((x) => x?.months);
  return ({
    api,
    column,
    operation,
    startIndex,
  }: {
    api: GridApi | null;
    column: Column | null | undefined;
    operation: "+" | "-" | "=";
    startIndex?: number;
  }) => {
    if (!api || !column) return;

    const selectedIndex = !isNullish(startIndex)
      ? startIndex
      : api.getCellRanges()?.sort((a, b) => {
          if (!a?.startRow || !b?.startRow) return 0;
          return a?.startRow?.rowIndex - b?.startRow?.rowIndex;
        })[0]?.startRow?.rowIndex;

    api.clearRangeSelection();

    api.addCellRange({
      columns: [column],
      rowStartIndex: selectedIndex ?? 0,
      rowEndIndex: (months.data ?? initGridSettings.months) - 1,
    });

    updateCellsByValueAndOperation({
      api,
      operation,
      clearSelection: true,
      reselect: {
        index: selectedIndex ?? 0,
        column,
      },
    });
  };
};
